import {
  Component,
  Input,
  OnInit,
  input,
  output,
  ChangeDetectionStrategy,
} from "@angular/core";
import { Subscription } from "rxjs";
import { SelectItem } from "primeng/api";
import { language } from "app/shared/language/language.const";
import { Bind } from "primeng/bind";
import { Select } from "primeng/select";
import { FormsModule } from "@angular/forms";

export interface StringChangeEvent {
  originalEvent: MouseEvent;
  value: string;
}

@Component({
  selector: "app-language-select",
  templateUrl: "./language-select.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [Bind, Select, FormsModule],
})
export class LanguageSelectComponent implements OnInit {
  public readonly languageChange = output<string>();
  @Input() public language = "Please select language";
  public readonly showMain = input(false);
  public readonly showClear = input(false);

  public subscription = new Subscription();
  public languageList: SelectItem[] = [];

  constructor() {}

  ngOnInit() {
    this.buildLanguageList();
  }

  public onLanguageChange(event: StringChangeEvent) {
    this.languageChange.emit(event.value);
  }

  private buildLanguageList() {
    if (this.showMain()) {
      this.languageList.push({
        label: "Main",
        value: "main",
      });
    }
    Object.keys(language).map((key) => {
      this.languageList.push({
        label: language[key].name,
        value: language[key].code,
      });
    });
  }
}
